export default __webpack_public_path__ + "static/media/Flag of Virgin Islands.c09f5037.gif";